import React, { useRef, useState } from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./Cardtamplate.css";

// import required modules
import { Autoplay, Pagination, Navigation } from "swiper";

export default function Cardtemplate() {
    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                }}
                navigation={true}
                modules={[Autoplay, Pagination, Navigation]}
                className="mySwiper2"
            >
                <SwiperSlide><a href='#'><img src='img/section3/section3_1.jpg' /></a></SwiperSlide>
                <SwiperSlide><a href='#'><img src='img/section3/section3_2.jpg' /></a></SwiperSlide>
                <SwiperSlide><a href='#'><img src='img/section3/section3_3.jpg' /></a></SwiperSlide>
                <SwiperSlide><a href='#'><img src='img/section3/section3_4.jpg' /></a></SwiperSlide>
                <SwiperSlide><a href='#'><img src='img/section3/section3_5.jpg' /></a></SwiperSlide>
                <SwiperSlide><a href='#'><img src='img/section3/section3_6.jpg' /></a></SwiperSlide>
                <SwiperSlide><a href='#'><img src='img/section3/section3_7.jpg' /></a></SwiperSlide>
            </Swiper>
        </>
    );
}